import React, { FC } from 'react'
import { TypeNewForm, TypeNewFormProps } from '../common/newType'

type ReportTypeFormProps = Omit<TypeNewFormProps, 'placeholder'>

export const ReportTypeNewForm: FC<ReportTypeFormProps> = (props) => {
  return <TypeNewForm {...props} placeholder="New Report Type Name" />
}
